import * as authentication from '@cascade/react/authentication';
import { useMemo } from 'react';
import {
  SIGN_IN_CALLBACK_PATHNAME,
  signInCallbackParams,
} from './Authentication.constants.ts';
import { parseSignInCallback } from './Authentication.helpers.ts';
import type { TAuthenticationProviderProps } from './Authentication.types.ts';
import { useConsumedSearchParams } from '#hooks/use-consumed-search-params/index.ts';

export const AuthenticationProvider = ({
  auth,
  children,
}: TAuthenticationProviderProps) => {
  const params = useConsumedSearchParams(signInCallbackParams, {
    pathname: SIGN_IN_CALLBACK_PATHNAME,
  });

  const signInCallback = useMemo(() => parseSignInCallback(params), [params]);

  return (
    <authentication.AuthenticationProvider
      auth={auth}
      signInCallback={signInCallback}
    >
      {children}
    </authentication.AuthenticationProvider>
  );
};
